import type { ReactNode } from 'react';
import React from 'react';
import { Typography } from '../Typography';
import styles from './Table.module.scss';

export interface RowModel {
	cells: ReactNode[];
	highlightColor?: string;
	id?: number;
	isHighlighted?: boolean;
}

interface TableProps {
	columns: string[];
	data: RowModel[];
	onRow?: (id: number | undefined) => void;
}

const Table = ({ columns, data, onRow }: TableProps) => (
	<table className={styles.customTable}>
		<thead>
			<tr className={styles.tableHeader}>
				{columns.map((col, index) => (
					<th key={`THeading-${index + 1}`} className={styles.tableCell}>
						<Typography variant='caption3' color='lightblue-40'>
							{col}
						</Typography>
					</th>
				))}
			</tr>
		</thead>
		<tbody className={styles.tableBody}>
			{data.map(({ cells, isHighlighted, id, highlightColor }, index) => {
				//const rowCells: RowModel[] = [...cells, ...Array(columns.length).fill(null)].slice(0, columns.length);
				return (
					<tr key={`TRow ${index + 1}`} className={`${styles.tableRow} ${isHighlighted ? styles.highlightedRow : ''} `}>
						{cells.map((cell, index) => (
							<td
								key={`TCell ${index + 1}`}
								className={styles.tableCell}
								style={{ background: highlightColor || undefined, width: `calc((100% - 8px) / ${columns.length})` }}
								onClick={() => onRow?.(id)}
							>
								{cell}
							</td>
						))}
					</tr>
				);
			})}
		</tbody>
	</table>
);

export default Table;
